import { AgentIconWithFallback } from 'ai-components-ui-library/components/icons/AgentIconWithFallback';
import { AuthorizationStatus, NotificationStatus } from 'connections-embed-lib';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { formatInstalls } from 'marketplace-ui-common/utils/installs';
import { renderCardButtons } from './internal/CardButtons';
import { useLazyImage } from './internal/LazyImageProvider';
import { MarketplaceCardBase } from './internal/MarketplaceCardBase';
import { MarketplaceCardClickable } from './internal/MarketplaceCardClickable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MarketplaceCardSmall({
  buttons,
  listing,
  onClick,
  tracker,
  trackingProps,
  transparent
}) {
  const product = listing.products[0];
  const cardButtons = renderCardButtons({
    buttons,
    listing
  });
  const content = /*#__PURE__*/_jsx(MarketplaceCardBase, {
    componentType: "MarketplaceCardSmall",
    listing: listing,
    tracker: tracker,
    trackingProps: trackingProps,
    children: /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsxs(MarketplaceCardClickable, {
        listing: listing,
        componentType: "MarketplaceCardSmall",
        display: "flex",
        flexGrow: 1,
        gap: "400",
        onClick: onClick,
        paddingBlock: "300",
        paddingInline: "400",
        trackingProps: trackingProps,
        children: [listing.betaStage && /*#__PURE__*/_jsx(Ribbon, {
          position: "left",
          use: "beta",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-embed.card.beta"
          })
        }), product.installed && product.productId && /*#__PURE__*/_jsx(NotificationStatus, {
          appId: product.productId,
          type: "ribbon"
        }), /*#__PURE__*/_jsx(ListingIcon, {
          listing: listing
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "50",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h4",
            typography: "heading-100",
            truncate: {
              lineClamp: 1
            },
            children: listing.listingName
          }), product.installed && product.productId && /*#__PURE__*/_jsx(View, {
            marginBlock: "-200",
            children: /*#__PURE__*/_jsx(AuthorizationStatus, {
              appId: product.productId,
              showInstalledStatus: true
            })
          }), !product.installed && /*#__PURE__*/_jsxs(Text, {
            as: "small",
            color: "text-core-subtle",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "span",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-embed.card.providerName",
                options: {
                  providerName: listing.companyName
                }
              })
            }), listing.installCount !== undefined && /*#__PURE__*/_jsx(Text, {
              as: "span",
              display: "inline-block",
              marginInlineStart: "400",
              whiteSpace: "nowrap",
              children: formatInstalls(listing.installCount)
            })]
          })]
        })]
      }), !!cardButtons.length && /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        marginInlineEnd: "400",
        children: cardButtons
      })]
    })
  });
  if (transparent) return content;
  return /*#__PURE__*/_jsx(CardWrapper, {
    marginBlockEnd: "0",
    blockSize: "100%",
    children: content
  });
}
function ListingIcon({
  listing
}) {
  const lazyImage = useLazyImage();
  const icon = /*#__PURE__*/_jsx(AgentIconWithFallback, {
    iconUrl: listing.iconUrl,
    loading: lazyImage,
    marginBlockEnd: "0",
    name: listing.listingName
    // accomodate the width of the border (if it exists)
    ,
    size: listing.iconUrl ? 40 : 38
  });
  return listing.iconUrl ? icon :
  /*#__PURE__*/
  // add a border because otherwise it clashes with the gray background and looks ugly
  _jsx(View, {
    borderColor: "border-accent-magenta-default",
    borderWidth: "100",
    borderRadius: "300",
    borderStyle: "solid",
    overflow: "hidden",
    children: icon
  });
}